var map = {
	"./views/AllDocument": [
		"8f3a",
		"chunk-b5033794"
	],
	"./views/AllDocument.vue": [
		"8f3a",
		"chunk-b5033794"
	],
	"./views/AllVideo": [
		"b47d",
		"chunk-38959822"
	],
	"./views/AllVideo.vue": [
		"b47d",
		"chunk-38959822"
	],
	"./views/Download": [
		"3971",
		"chunk-15bc5750"
	],
	"./views/Download.vue": [
		"3971",
		"chunk-15bc5750"
	],
	"./views/Novice": [
		"42b5",
		"chunk-935dcbae"
	],
	"./views/Novice.vue": [
		"42b5",
		"chunk-935dcbae"
	],
	"./views/NoviceDetail": [
		"320d",
		"chunk-d67d531e"
	],
	"./views/NoviceDetail.vue": [
		"320d",
		"chunk-d67d531e"
	],
	"./views/Question": [
		"e2540",
		"chunk-f2140470"
	],
	"./views/Question.vue": [
		"e2540",
		"chunk-f2140470"
	],
	"./views/QuestionContents": [
		"cf48",
		"chunk-2d22271d"
	],
	"./views/QuestionContents.vue": [
		"cf48",
		"chunk-2d22271d"
	],
	"./views/QuestionDetail": [
		"51b6",
		"chunk-1a8be046"
	],
	"./views/QuestionDetail.vue": [
		"51b6",
		"chunk-1a8be046"
	],
	"./views/SearchResult": [
		"9820",
		"chunk-ff5a42e2"
	],
	"./views/SearchResult.vue": [
		"9820",
		"chunk-ff5a42e2"
	],
	"./views/Video": [
		"81a8",
		"chunk-2d0dd9a6"
	],
	"./views/Video.vue": [
		"81a8",
		"chunk-2d0dd9a6"
	],
	"./views/VideoDetail": [
		"b96c",
		"chunk-0ac57cc7"
	],
	"./views/VideoDetail.vue": [
		"b96c",
		"chunk-0ac57cc7"
	],
	"./views/VideoList": [
		"f0d0",
		"chunk-51b0db76"
	],
	"./views/VideoList.vue": [
		"f0d0",
		"chunk-51b0db76"
	],
	"./views/document": [
		"557c",
		"chunk-4ca4f1fc"
	],
	"./views/document.vue": [
		"557c",
		"chunk-4ca4f1fc"
	],
	"./views/feedback": [
		"c6bd",
		"chunk-7f19ddef"
	],
	"./views/feedback.vue": [
		"c6bd",
		"chunk-7f19ddef"
	],
	"./views/pages_wap": [
		"b2d6",
		"chunk-2d20f558"
	],
	"./views/pages_wap/": [
		"b2d6",
		"chunk-2d20f558"
	],
	"./views/pages_wap/AllDocument": [
		"e6b9",
		"chunk-a55ef4ac"
	],
	"./views/pages_wap/AllDocument.vue": [
		"e6b9",
		"chunk-a55ef4ac"
	],
	"./views/pages_wap/AllVideo": [
		"182e",
		"chunk-409a415a"
	],
	"./views/pages_wap/AllVideo.vue": [
		"182e",
		"chunk-409a415a"
	],
	"./views/pages_wap/Download": [
		"ecc1",
		"chunk-2eb03466"
	],
	"./views/pages_wap/Download.vue": [
		"ecc1",
		"chunk-2eb03466"
	],
	"./views/pages_wap/Search": [
		"a2a7",
		"chunk-561ac15c"
	],
	"./views/pages_wap/Search.vue": [
		"a2a7",
		"chunk-561ac15c"
	],
	"./views/pages_wap/SearchResult": [
		"ec6c",
		"chunk-50211922"
	],
	"./views/pages_wap/SearchResult.vue": [
		"ec6c",
		"chunk-50211922"
	],
	"./views/pages_wap/feedback": [
		"fce2",
		"chunk-dc85c5e4"
	],
	"./views/pages_wap/feedback.vue": [
		"fce2",
		"chunk-dc85c5e4"
	],
	"./views/pages_wap/getToken": [
		"a94a",
		"chunk-810778e8"
	],
	"./views/pages_wap/getToken.vue": [
		"a94a",
		"chunk-810778e8"
	],
	"./views/pages_wap/index": [
		"b2d6",
		"chunk-2d20f558"
	],
	"./views/pages_wap/index.vue": [
		"b2d6",
		"chunk-2d20f558"
	],
	"./views/pages_wap/novice": [
		"b1a1",
		"chunk-49e547e5"
	],
	"./views/pages_wap/novice/": [
		"b1a1",
		"chunk-49e547e5"
	],
	"./views/pages_wap/novice/NoviceDetail": [
		"3fbc",
		"chunk-3e07e566"
	],
	"./views/pages_wap/novice/NoviceDetail.vue": [
		"3fbc",
		"chunk-3e07e566"
	],
	"./views/pages_wap/novice/index": [
		"b1a1",
		"chunk-49e547e5"
	],
	"./views/pages_wap/novice/index.vue": [
		"b1a1",
		"chunk-49e547e5"
	],
	"./views/pages_wap/question": [
		"9a15",
		"chunk-2d0efc62"
	],
	"./views/pages_wap/question/": [
		"9a15",
		"chunk-2d0efc62"
	],
	"./views/pages_wap/question/QuestionContents": [
		"acb4",
		"chunk-1275a924"
	],
	"./views/pages_wap/question/QuestionContents.vue": [
		"acb4",
		"chunk-1275a924"
	],
	"./views/pages_wap/question/QuestionDetail": [
		"26d4",
		"chunk-7b269daa"
	],
	"./views/pages_wap/question/QuestionDetail.vue": [
		"26d4",
		"chunk-7b269daa"
	],
	"./views/pages_wap/question/index": [
		"9a15",
		"chunk-2d0efc62"
	],
	"./views/pages_wap/question/index.vue": [
		"9a15",
		"chunk-2d0efc62"
	],
	"./views/pages_wap/video": [
		"b6a2",
		"chunk-2d2103fb"
	],
	"./views/pages_wap/video/": [
		"b6a2",
		"chunk-2d2103fb"
	],
	"./views/pages_wap/video/VideoDetail": [
		"71e5",
		"chunk-4ef1a8cd"
	],
	"./views/pages_wap/video/VideoDetail.vue": [
		"71e5",
		"chunk-4ef1a8cd"
	],
	"./views/pages_wap/video/VideoList": [
		"6079",
		"chunk-6205434a"
	],
	"./views/pages_wap/video/VideoList.vue": [
		"6079",
		"chunk-6205434a"
	],
	"./views/pages_wap/video/index": [
		"b6a2",
		"chunk-2d2103fb"
	],
	"./views/pages_wap/video/index.vue": [
		"b6a2",
		"chunk-2d2103fb"
	],
	"./views/videoPlayer": [
		"cf8f",
		"chunk-2d2227c7"
	],
	"./views/videoPlayer.vue": [
		"cf8f",
		"chunk-2d2227c7"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2a68";
module.exports = webpackAsyncContext;